// src/packages/chubb/pa/chubb_pa_series_d_2025/ChubbPASeriesDCard.jsx
import React from "react";
import "./chubb_pa_series_d.css";

export default function ChubbPASeriesDCard({ onSelect }) {
  return (
    <div className="pkg-card chubb-pa-d">
      <div className="pkg-body">
        <h3>Chubb PA Series D (แผน 1–8 + Kid)</h3>
        <p>อุบัติเหตุส่วนบุคคล • ค่ารักษา • วันหยุดสาธารณะ • มอเตอร์ไซค์</p>
        <ul className="pkg-list">
          <li>ทุนชีวิต/ทุพพลภาพ สูงสุดตามแผน</li>
          <li>ค่ารักษาพยาบาล/ครั้ง + สิทธิพิเศษอื่น ๆ</li>
          <li>ทำได้ทั้งเดี่ยว / คู่สมรส / ครอบครัว</li>
        </ul>
        <button className="pkg-btn" onClick={onSelect}>ดูรายละเอียด</button>
      </div>
    </div>
  );
}
